$(document).ready(function(){
  $('#term-agree').on('change', function(e){
    const isChecked = $(this).is(':checked');
    if(isChecked) {
      $('.cancellation-form').addClass('active');
    } else {
      $('.cancellation-form').removeClass('active');
    }
  });

  /** Bundle option */
  $('.bundle-options-list .option-header').on('click', function() {
    $(this).find('.toggle-collapse').toggleClass('collapsed');
    $(this).parent('.bundle-option').find('.option-content').slideToggle();
  });

  $('.select-bundle-options-wrapper .selection-header .collapse-link').on('click', function(e) {
    e.preventDefault();

    $(this).addClass('hidden');
    $('.select-bundle-options-wrapper .selection-header .expand-link').removeClass('hidden');
    $('.bundle-options-list .option-header .toggle-collapse').removeClass('collapsed').addClass('collapsed');
    $('.bundle-options-list .bundle-option .option-content').slideUp();
  });

  $('.select-bundle-options-wrapper .selection-header .expand-link').on('click', function(e) {
    e.preventDefault();

    $(this).addClass('hidden');
    $('.select-bundle-options-wrapper .selection-header .collapse-link').removeClass('hidden');
    $('.bundle-options-list .option-header .toggle-collapse').removeClass('collapsed');
    $('.bundle-options-list .bundle-option .option-content').slideDown();
  });

  var priceCalculation = () => {
    var bundleMainPrice = 0;

    if ( $('.bundle-product-qty').length > 0 ) {
      $('.bundle-product-qty').each(function() {
        var $this = $(this);
        var bundleVal = parseInt( $this.val() );
        var bundlePrice = $this.data('price').toString();
        var bundlePriceVal = parseFloat(bundlePrice.replace(',', ''));

        if ( bundleVal > 0 ) {
          bundleMainPrice = bundleMainPrice + ( bundlePriceVal * bundleVal );
        }
      });
    }
    
    $('.product-bundle .product-shop .prices .price').text('$' + bundleMainPrice.toFixed(2));
  }
  priceCalculation();

  $('.bundle-options-list .product-cta-wrap .bundle-select-btn').on('click', function() {
    if ( $(this).hasClass('bundle-radio-select-btn') ) {
      if ( $(this).hasClass('selected') ) {
        $(this).removeClass('selected');
        $(this).parents('.bundle-product').find('.bundle-checker').removeClass('true');
        $(this).parents('.bundle-product').find('.bundle-product-qty').val(0).trigger("change");
      } else {
        $(this).addClass('selected');
        $(this).parents('.bundle-product').find('.bundle-checker').addClass('true');
        $(this).parents('.bundle-product').find('.bundle-product-qty').val(1).trigger("change");
      }
    } else {
      $(this).parents('.option-content').find('.bundle-select-btn').removeClass('selected');
      $(this).addClass('selected');
  
      var bundleIndex = $(this).data('bundleindex');
      // var nextBundle = $('#' + bundleIndex);
  
      // if ( nextBundle.length > 0 ) {
      //   $("html, body").animate({
      //     scrollTop: nextBundle.offset().top - 50
      //   }, 500);
      // }
  
      $(this).parents('.option-content').find('.bundle-product-qty').val(0).trigger("change");
      $(this).parents('.bundle-product').find('.bundle-product-qty').val(1).trigger("change");
    }
    priceCalculation();
  });

  $('.bundle-qty-group .minus').on('click', function(e) {
    e.preventDefault();

    var $this = $(this),
        qty = $this.next('.bundle-product-qty'),
        qtyVal = parseInt(qty.val());

    if ( qtyVal > 1 ) {
      qty.val(qtyVal - 1).trigger("change");
    }
    priceCalculation();
  });

  $('.bundle-qty-group .plus').on('click', function(e) {
    e.preventDefault();

    var $this = $(this),
        qty = $this.prev('.bundle-product-qty'),
        qtyVal = parseInt(qty.val());

    qty.val(qtyVal + 1).trigger("change");
    priceCalculation();
  });

  var cartParams = [];
  if ( $('.bundle-product-qty').length > 0 ) {
    $('.bundle-product-qty').each(function() {
      var $this = $(this);
  
      var bundleQtyCtrler = () => {
        var bundleProduct = $this;
        var bundleVariantID = bundleProduct.attr('id'); 
        
        if ( bundleVariantID != 'no-drain-plug-option' ) {
          if ( parseInt( bundleProduct.val() ) > 0 ) {
            if (cartParams.some(item => item.id === bundleVariantID)) {
              cartParams.map(param => {
                if ( param.id ==  bundleVariantID) param.quantity = bundleProduct.val();
              });
            } else {
              cartParams.push({
                id: bundleVariantID,
                quantity: bundleProduct.val()
              });
            }
          } else {
            cartParams = $.grep(cartParams, function(e){ 
              return e.id != bundleVariantID; 
            });
          }
        }
      }
  
      bundleQtyCtrler();
      $this.change(function() {
        bundleQtyCtrler();
      });
    });
  }

  $('.product-bundle #bundle-products-add').on('click', function(e) {
    $.ajax({ // Add items to Cart
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: cartParams
      },
      dataType: 'json',
      // beforeSend: function () {
      //   $('.product-bundle #bundle-products-add').addClass('loading');
      // },
      success: function() {
        $('.product-bundle #product-add-to-cart').click();
        // $('.product-bundle #bundle-products-add').removeClass('loading');
      }
    });
  });
});